// extracted by mini-css-extract-plugin
export default {"messageContainer":"MessageContainer_messageContainer__2-4hk"};